export function request(id) {
    id = parseInt(id, 10);

    return {
        type: 'CUSTOMERS_GET_COUNTERS_REQUEST',
        id
    };
}

export function error(id, errors) {
    id = parseInt(id, 10);

    return {
        type: 'CUSTOMERS_GET_COUNTERS_ERROR',
        errors,
        id
    };
}

export function finish(id, data) {
    id = parseInt(id, 10);

    return {
        type: 'CUSTOMERS_GET_COUNTERS_FINISH',
        id,
        data
    };
}

export function clear() {
    return {
        type: 'CUSTOMERS_GET_COUNTERS_CLEAR'
    };
}
